<div class="fh-menu-item-wrapper" [id]="item.id">
  <div
    class="fh-menu-item fh-btn"
    role="menuitem"
    [attr.aria-expanded]="item.dropdownOpen ? 'true' : 'false'"
    [attr.aria-label]="item.title | translate"
    (click)="navigate()"
    [ngClass]="{
      'mb-2': isDropdownItem(),
      active: item.active,
      'dropdown-active': item.dropdownOpen,
      menuNotExpanded: !isMenuExpanded()
    }">
    <div class="row w-100 h-100 m-0">
      <div class="h-100 d-flex align-items-center col-item ps-0" [ngClass]="{ 'col-10': isMenuExpanded(), 'p-0': !isMenuExpanded() }">
        <!-- Ícone quando o menu está expandido -->
        <div *ngIf="item.icon && isMenuExpanded()" class="item-icon mr-3 margin-item-icon">
          <i *ngIf="item.icon" class="{{ item.icon }} icon" aria-hidden="true"></i>
        </div>

        <!-- Ícone quando o menu está recolhido, com tooltip corretamente associado -->
        <div
          *ngIf="item.icon && !isMenuExpanded()"
          pTooltip="{{ item.title | translate }}"
          tooltipPosition="right"
          appendTo="body"
          class="item-icon mr-3 margin-item-icon"
          [attr.aria-describedby]="'tooltip-' + item.id">
          <i *ngIf="item.icon" class="{{ item.icon }} icon" aria-hidden="true"></i>
        </div>

        <div class="item-text">
          <label *ngIf="isMenuExpanded()" id="'tooltip-' + item.id">
            {{ item.title | translate }}
          </label>
        </div>
      </div>

      <!-- Ícone do dropdown -->
      <div class="col-2 align-items-center justify-content-end col-nav-link">
        <i class="{{ icon }} fa-chevron-right fh-nav-link" [ngClass]="{ 'fa-rotate-90': item.dropdownOpen }" aria-hidden="true"></i>
      </div>
    </div>
  </div>

  <!-- Submenu -->
  <div
    #dropdownEl
    class="dropdown-item"
    role="menu"
    [ngClass]="{
      'dropdown-floating': !isMenuExpanded(),
      'dropdown-item-child': item.level > 0
    }"
    *ngIf="item.dropdownOpen">
    <ui-fh-menu-dropdown [validateFeatures]="true" [parentItem]="item" [items]="item.childs!"></ui-fh-menu-dropdown>
  </div>
</div>
